import controller from './query-builder-children.controller';
import template from './query-builder-children.html';
import './query-builder-children.scss';

export default {
	controller,
	template,
	bindings: {
		disabled:    '<?ngDisabled',
		formBuilder: '<?formBuilderComponent',
		group:       '<ngModel',
		options:     '<?',
		root:        '<?',
	},
	require:  {
		ngModelCtrl: '?ngModel',
		editor:      '^^?queryEditor',
		parent:      '^^?queryBuilderChildren',
		parentGroup: '^^?queryBuilderChildrenGroup',
	},
};
